import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class SupportRequest
 */
export class SupportRequest extends Model {


    static get validationModel() {

        return {
            name: {
                label: 'CURRENCY_NAME_IN_ENGLISH',
                commonLabel: 'Currency name'
            },
            name_ar: {
                label: 'CURRENCY_NAME_IN_ARABIC',
                commonLabel: 'Currency name'
            },
        };
    }

    static get SUBJECT() {

        return {
            '1': 'SALES',
            '2': 'TECHNICAL_SUPPORT',
            '3': 'PRODUCT_FEATURES',
            '4': 'BILLING_N_PAYMENTS',
            '5': 'GENERAL_OTHERS',
        };
    }

    toObject(...keys) {

        const object = angular.copy(super.toObject(...keys));

        if (object['country']) {

            object['country'] = object['country'].name;
        }

        if (object['phone_code'] && object['phone_number']) {

            object['phone'] = object['phone_code'] + object['phone_number'];
            delete object['phone_code'];
            delete object['phone_number'];
        }

        return object;
    }
}

AccessorsMutatorsDecorator(
    'company_name',
    'full_name',
    'email',
    'phone_code',
    'phone_number',
    'country',
    'subject',
    'message'
)(SupportRequest);



// WEBPACK FOOTER //
// ./src/pms-api/models/support-request.model.js